export interface FormFields {
  [name: string]: string | number;
}

function encode(value: string | number): string {
  return encodeURIComponent(String(value)).replace(/%20/g, '+');
}

export function encodeForm(fields: FormFields): string {
  return Object.keys(fields).map(function (name) {
    return encode(name) + '=' + encode(fields[name]);
  }).join('&');
}

export function buildApiUrl(baseUrl: string, path: string): string {
  return baseUrl.replace(/\/+$/, '') + '/' + path.replace(/^\/+/, '');
}

export function mapNetworkFailure<T>(request: Promise<T>, createError: () => Error): Promise<T> {
  return request.catch(function () {
    return Promise.reject(createError());
  });
}



// WEBPACK FOOTER //
// ./src/providers/api-http/form-url-encoded.ts